<template>
  <div>
    <!-- Loader -->
    <div v-if="loading_page">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions" />
      </v-sheet>
    </div>

    <!-- Content -->
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_status">เปลี่ยนสถานะเรียบร้อย !</v-alert>
        <v-alert type="success" class="alert" v-if="alert_status_remark">เพิ่มหมายเหตุเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_delete">ลบบทความเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>

      <v-card elevation="6">
        <!-- Header: Title + Status Select -->
        <div class="pa-3 d-flex align-center">
          <div class="mt-2" style="font-size: 22px;">รายการใบ PU</div>
          <v-spacer />
          <v-select class=" mt-2" v-model="headerStatus" :items="statusOptions" item-text="name" item-value="id"
            label="กรุณาเลือกสถานะ" dense outlined hide-details style="max-width: 200px;" />
          <v-btn color="#86bc3a" style="font-size: 18px;" class="ml-2 mt-2" dark @click="bulkUpdateStatus">
            เปลี่ยนสถานะ
          </v-btn>
        </div>

        <!-- Search -->
        <v-card-title>
          <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line
            hide-details />
        </v-card-title>

        <!-- Data Table -->
        <v-data-table :headers="headers" :items="data_list" item-key="id" :footer-props="footer_Props" :search="search"
          mobile-breakpoint="0" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :custom-sort="customSort"
          :page.sync="page" :items-per-page.sync="itemsPerPage">
          <template v-slot:item="dataDetail">
            <tr :key="dataDetail.item.id">
              <!-- Index -->
              <td>{{ dataDetail.index + 1 }}</td>

              <!-- PU Receipt No. -->
              <td>{{ dataDetail.item.receipt_no }}</td>

              <!-- Supplier Name -->
              <td>{{ dataDetail.item.supplier_name }}</td>

              <!-- Credit Date -->
              <td>{{ dataDetail.item.credit_date || '-' }}</td>

              <!-- Total -->
              <td v-if="dataDetail.item.type === 1">
                <span :class="parseFloat(dataDetail.item.total) > 0 ? 'red--text' : ''">-{{
                  format_number(dataDetail.item.total) }}</span>
              </td>
              <td v-else>{{ format_number(dataDetail.item.total) }}</td>

              <!-- Inline Status Select -->
              <td>
                <div v-if="dataDetail.item.is_credit_pay === 0" class="">
                  <v-select color="#86bc3a" :items="statusOptions" item-text="name" item-value="id"
                    v-model="dataDetail.item.is_credit_pay"
                    @input="changeStatus(dataDetail.item.id, dataDetail.item.is_credit_pay, dataDetail.item.type)"
                    label="กรุณาเลือกสถานะ" hide-details dense outlined />
                </div>
                <div v-else>ชำระเรียบร้อย</div>
              </td>

              <!-- Checkbox -->
              <td>
                <v-checkbox style="margin-top: -7px;" v-model="selectedRows" :value="dataDetail.item.id" hide-details
                  dense color="#86bc3a" />
              </td>

              <!-- Actions -->
              <td class="pa-3">
                <div class="d-flex align-center flex-wrap">
                  <v-btn v-if="dataDetail.item.import_type === 1" x-large @click="getDetailsPO(dataDetail.item.id)"
                    class="ma-2 pa-6 grad-success-bg white--text" style="font-size: 18px">
                    <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                  </v-btn>

                  <v-btn v-else-if="dataDetail.item.import_type === 2" x-large @click="getDetailsPR(dataDetail.item.id)"
                    class="ma-2 pa-6 grad-success-bg white--text" style="font-size: 18px">
                    <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                  </v-btn>

                  <v-btn v-else-if="dataDetail.item.type === 1" x-large @click="getDetailsType(dataDetail.item.doc_no)"
                    class="ma-2 pa-6 grad-success-bg white--text" style="font-size: 18px">
                    <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                  </v-btn>

                  <!-- ปุ่มหมายเหตุ ให้วาง inline ถัดมา -->
                  <v-btn 
                    x-large 
                    @click="getRemarks(dataDetail.item.id,dataDetail.item.is_credit_pay)" 
                    class="ma-2 pa-2" 
                    :color="dataDetail.item.remark ? 'green darken-2' : 'blue darken-2'" 
                    dark 
                    style="font-size: 18px">
                    <v-icon v-if="dataDetail.item.remark" left>mdi-note-text</v-icon>
                    หมายเหตุ
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-dialog v-model="showRemarksDialog" max-width="500px" persistent>
          <v-card>
            <v-card-title class="headline">เพิ่มหมายเหตุ</v-card-title>
            <v-card-text>
              <v-textarea v-model="remarkText" label="หมายเหตุ" rows="4" outlined />
              
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn text @click="showRemarksDialog = false">ยกเลิก</v-btn>
              <v-btn color="blue darken-2" dark @click="saveRemark">
                บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
import { formatNumber } from "@/js/handler";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: { default: { isDark: false } },
  },
  data() {
    return {
      sortBy: "is_credit_pay",
      sortDesc: false,
      loading_page: false,
      search: "",
      alert_status: false,
      alert_status_remark: false,
      alert_delete: false,
      page: 1,                // current page
      itemsPerPage: 10,
      headerStatus: null,      // สถานะจาก header
      selectedRows: [],        // เก็บ id ของแถวที่ติ๊ก
      statusOptions: [
        { id: 0, name: "ค้างชำระ" },
        { id: 1, name: "ชำระเรียบร้อย" },
      ],
      showRemarksDialog: false,
      remarkText: "",
      remarkItemId: null,
      remarkItemType: null,
      footer_Props: { "items-per-page-text": "รายการต่อหน้า" },
      headers: [
        { text: "ลำดับ", value: "id", width: "90px" },
        { text: "หมายเลข PU", value: "receipt_no", width: "160px" },
        { text: "ซัพพลายเออร์", value: "supplier_name", width: "150px" },
        { text: 'วันที่ครบกำหนด', value: 'credit_date_raw', width: '180px' },
        { text: "ยอดค้างชำระ", value: "total", width: "150px" },
        { text: "สถานะการชำระ", value: "is_credit_pay", sortable: false, width: "100px" },
        { text: 'เลือก', value: 'select', sortable: false, width: '50px' },
        { text: "จัดการ", value: "action", sortable: false, width: "340px", align: "center" },
      ],
      data_list: [],
    };
  },
  methods: {
    format_number(v) {
      return formatNumber(v);
    },
    getDetailsPO(id) {
      this.$router.push("/creditor/pudetails/" + id);
    },
    getDetailsPR(id) {
      this.$router.push("/creditor/pudetailspr/" + id);
    },
    getDetailsType(doc_no) {
      window.open("/stock/document/documentdetailscomplete/" + doc_no, "_blank");
    },
    onSingleSelect(id, checked) {
      this.selectedRow = checked ? id : null;
    },
    get_data() {
      this.loading_page = true;
      HTTP.post("creditor/getallpu")
        .then((res) => {
          if (res.data.success) {
            this.data_list = res.data.object;
          }
          this.loading_page = false;
        });
    },
    changeStatus(id, status, type) {
      Swal.fire({
        text: "คุณต้องการเปลี่ยนสถานะการชำระหรือไม่ ?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "ตกลง",
        denyButtonText: "ยกเลิก",
      }).then((res) => {
        if (res.isConfirmed) {
          HTTP.post("creditor/changestatus", { id, status, type }).then((r) => {
            if (r.data.success) {
              this.alert_status = true;
              setTimeout(() => (this.alert_status = false), 2000);
            } else {
              Swal.fire("ผิดพลาด", r.data.message, "error");
            }
            this.get_data();
          });
        } else {
          this.get_data();
        }
      });
    },
    //   showCheckID() {
    //   const rows = this.selectedRows;
    //   const statusId = this.headerStatus;
    //   const statusOpt = this.statusOptions.find(o => o.id === statusId);

    //   if (!rows.length && statusId === null) {
    //     Swal.fire({
    //       icon: 'warning',
    //       text: 'กรุณาเลือกสถานะและ/หรือ รายการอย่างน้อยหนึ่งรายการก่อน',
    //       confirmButtonText: 'ตกลง'
    //     });
    //     return;
    //   }

    //   let message = '';
    //   if (rows.length) {
    //     message += `ID รายการที่เลือก: ${rows.join(', ')}`;
    //   }
    //   if (statusId !== null) {
    //     if (message) message += '\n';
    //     message += `สถานะที่เลือก: ${statusId}` + (statusOpt ? ` (${statusOpt.name})` : '');
    //   }

    //   Swal.fire({
    //     icon: 'info',
    //     title: 'ข้อมูลที่เลือก',
    //     text: message,
    //     confirmButtonText: 'ปิด'
    //   });
    // },
    bulkUpdateStatus() {
      const rows = this.selectedRows;
      const statusId = this.headerStatus;

      // 1) ตรวจว่ามีการเลือกทั้งสองอย่าง
      if (!rows.length) {
        return Swal.fire({
          icon: 'warning',
          text: 'กรุณาเลือกอย่างน้อยหนึ่งรายการก่อน',
          confirmButtonText: 'ตกลง'
        });
      }
      if (statusId === null) {
        return Swal.fire({
          icon: 'warning',
          text: 'กรุณาเลือกสถานะก่อน',
          confirmButtonText: 'ตกลง'
        });
      }

      // 2) ยืนยันก่อนส่ง
      Swal.fire({
        text: 'คุณต้องการอัปเดตสถานะของรายการที่เลือกหรือไม่?',
        icon: 'warning',
        showDenyButton: true,
        confirmButtonText: 'ตกลง',
        denyButtonText: 'ยกเลิก',
      }).then(res => {
        if (res.isConfirmed) {
          // 4) ส่ง HTTP.post สำหรับแต่ละรายการ
          const requests = rows.map(id =>
            HTTP.post('creditor/changestatus', { id, status: statusId })
          );

          Promise.all(requests)
            .then(() => {
              // 5) ถ้าทุกรายการสำเร็จ แสดง alert_status
              this.alert_status = true;
              setTimeout(() => (this.alert_status = false), 2000);
              // รีโหลดข้อมูล และเคลียร์การเลือก
              this.get_data();
              this.selectedRows = [];
              this.headerStatus = null;
            })
            .catch(() => {
              Swal.fire('ผิดพลาด', 'เกิดข้อผิดพลาดขณะอัปเดตสถานะ', 'error');
              this.get_data();
            });
        } else {
          // ถ้า user ยกเลิก ให้รีโหลดข้อมูล
          this.get_data();
        }
      });
    },
    getRemarks(id,type) {
      this.remarkItemId = id;
      this.remarkItemType = type;
      const item = this.data_list.find(i => i.id === id) || {};
      this.remarkText = item.remark || '';
      this.showRemarksDialog = true;
    },
    saveRemark() {
      
      HTTP.post('creditor/saveRemark', { id: this.remarkItemId, type: this.remarkItemType, remark: this.remarkText })
        .then(res => {
          if (res.data.success) {
            this.alert_status_remark = true;
            setTimeout(() => (this.alert_status_remark = false), 2000);
            this.showRemarksDialog = false;
            this.get_data();
          } else {
            Swal.fire('ผิดพลาด', res.data.message || 'ไม่สามารถบันทึกได้', 'error');
          }
        }).catch(() => {
          Swal.fire('ผิดพลาด', 'เกิดข้อผิดพลาดขณะเชื่อมต่อ', 'error');
        });
    },
  },
  
  watch: {
    // page() {
    //   this.selectedRows = [];
    // },
    // // เคลียร์ checkbox เมื่อเปลี่ยนจำนวนรายการต่อหน้า
    // itemsPerPage() {
    //   this.selectedRows = [];
    // },
    // // 1) เคลียร์การติ๊ก checkbox ทุกครั้งที่ค้นหา
    // search() {
    //   this.selectedRows = [];
    // },
    // sortBy() {
    //   this.selectedRows = []
    // },
    // sortDesc() {
    //   this.selectedRows = []
    // },

  },

  mounted() {
    this.get_data();
  },
};
</script>

<style scoped>
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
</style>
